import { Injectable } from '@angular/core';
import {
  LinkedProduct,
  LinkedProductWithLinkable
} from 'src/app/models/linked-product';
import { Product } from 'src/app/models/product';
import { RetailProduct } from 'src/app/models/retail-product';
import { ApiClient } from '../api.client';
@Injectable()
export class LinkedProductsService {
  private prefix = 'products';
  private resourceEndpoint = 'links';

  constructor(private http: ApiClient) {}

  public getAll(productId: number) {
    return this.http.get<LinkedProductWithLinkable<Product | RetailProduct>[]>(
      `${this.prefix}/${productId}/${this.resourceEndpoint}`
    );
  }

  public create(
    productId: number,
    linkedProduct: Omit<
      LinkedProduct,
      'id' | 'updated_at' | 'created_at' | 'deleted_at'
    >
  ) {
    return this.http.post<LinkedProductWithLinkable<Product | RetailProduct>>(
      `${this.prefix}/${productId}/${this.resourceEndpoint}`,
      linkedProduct
    );
  }

  public update(productId: number, linkedProduct: LinkedProduct) {
    return this.http.put<LinkedProductWithLinkable<Product | RetailProduct>>(
      `${this.prefix}/${productId}/${this.resourceEndpoint}/${linkedProduct.id}`,
      linkedProduct
    );
  }

  public delete(productId: number, linkedProductId: number) {
    return this.http.delete<void>(
      `${this.prefix}/${productId}/${this.resourceEndpoint}/${linkedProductId}`
    );
  }

  public getLinkedProductsAndTheirItems(productId: number) {
    return this.http.get<LinkedProductWithLinkable<Product>[]>(
      `${this.prefix}/${productId}/hire-products`
    );
  }
}
